import { render, staticRenderFns } from "./OrderDetailHeader.vue?vue&type=template&id=ff96d1e0&scoped=true&"
import script from "./OrderDetailHeader.vue?vue&type=script&lang=js&"
export * from "./OrderDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailHeader.vue?vue&type=style&index=0&id=ff96d1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff96d1e0",
  null
  
)

export default component.exports